const host = {
  dev: 'https://pocket-api.51yestech.com',
  prod: 'https://api.kday123.com',
};
module.exports = host;
